import {
  GET_ADMIN_INSURANCE_CARRIERS,
  GET_ADMIN_INSURANCE_CARRIERS_SUCCESS,
  GET_ADMIN_INSURANCE_CARRIERS_ERROR,
  CRETE_ADMIN_INSURANCE_CARRIER,
  CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  CRETE_ADMIN_INSURANCE_CARRIER_ERROR,
  UPDATE_ADMIN_INSURANCE_CARRIER,
  UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  UPDATE_ADMIN_INSURANCE_CARRIER_ERROR
} from "./actionTypes"

export const getAdminInsuranceCarriers = (query_params, paginated) => {
  return {
    type: GET_ADMIN_INSURANCE_CARRIERS,
    payload: query_params,
    paginated: paginated
  }
}

export const getAdminInsuranceCarriersSuccess = (event) => ({
  type: GET_ADMIN_INSURANCE_CARRIERS_SUCCESS,
  payload: event
})

export const getAdminInsuranceCarriersError = (error) => ({
  type: GET_ADMIN_INSURANCE_CARRIERS_ERROR,
  payload: error
})

export const addAdminInsuranceCarrier = (insurance_carriers) => {
  return {
    type: CRETE_ADMIN_INSURANCE_CARRIER,
    payload: insurance_carriers,
  }
}

export const addAdminInsuranceCarrierSuccess = (event) => ({
  type: CRETE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  payload: event
})

export const addAdminInsuranceCarrierError = (error) => ({
  type: CRETE_ADMIN_INSURANCE_CARRIER_ERROR,
  payload: error
})

export const updateAdminInsuranceCarrier = (insurance_carriers) => {
  return {
    type: UPDATE_ADMIN_INSURANCE_CARRIER,
    payload: insurance_carriers
  }
}

export const updateAdminInsuranceCarrierSuccess = (event) => ({
  type: UPDATE_ADMIN_INSURANCE_CARRIER_SUCCESS,
  payload: event
})

export const updateAdminInsuranceCarrierError = (error) => ({
  type: UPDATE_ADMIN_INSURANCE_CARRIER_ERROR,
  payload: error
})
